'use client'

import { ErrorBoundary } from 'react-error-boundary'

import { Dialog, Separator } from '@/shared/ui'

import { ContractInformation } from './contract-information'
import type { Props as ContractInformationProps } from './contract-information'
import { PaymentNotice } from './notice'
import { PaymentButton } from './payment-button'
import { PaymentMethod, PaymentMethodFallback } from './payment-method'
import { TossWidgetProvider } from '../../lib/toss-widget'

export type Props = ContractInformationProps & {
  isOpen: boolean
  onOpenChange: (isOpen: boolean) => void
}

export const PaymentDialog = ({
  isOpen,
  onOpenChange,
  ...restProps
}: Props) => {
  return (
    <TossWidgetProvider>
      <Dialog.Root open={isOpen} onOpenChange={onOpenChange}>
        <Dialog.Content className="h-[760px] gap-0 p-0 text-center">
          <Dialog.Header className="p-6">
            <Dialog.Title className="text-start">카드 결제</Dialog.Title>
          </Dialog.Header>

          <div className="scrollbar thick grow overflow-y-auto">
            <ContractInformation {...restProps} />
            <Separator size="medium" color="light-gray" />
            <ErrorBoundary FallbackComponent={PaymentMethodFallback}>
              <PaymentMethod />
            </ErrorBoundary>
            <PaymentNotice />
          </div>

          <Dialog.Footer className="w-full p-6">
            <PaymentButton />
          </Dialog.Footer>
        </Dialog.Content>
      </Dialog.Root>
    </TossWidgetProvider>
  )
}
